export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-black text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/419bcc41-8f35-407d-bf53-cba158dc2238.png" 
                alt="ESCRITORIO BENDER LTDA Logo" 
                className="h-10 w-10 object-contain"
              />
              <h3 className="text-2xl font-bold">ESCRITORIO BENDER LTDA</h3>
            </div>
            <p className="text-gray-400 text-sm mb-6 leading-relaxed">
              Protecting your digital privacy with enterprise-grade VPN technology.
            </p>
            <div className="flex gap-4">
              <a
                href="#"
                className="w-10 h-10 border border-gray-700 rounded-full flex items-center justify-center hover:border-purple-500 hover:text-purple-500 transition-colors cursor-pointer"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 border border-gray-700 rounded-full flex items-center justify-center hover:border-purple-500 hover:text-purple-500 transition-colors cursor-pointer"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 border border-gray-700 rounded-full flex items-center justify-center hover:border-purple-500 hover:text-purple-500 transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 border border-gray-700 rounded-full flex items-center justify-center hover:border-purple-500 hover:text-purple-500 transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide mb-6">Contact</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <i className="ri-mail-line text-lg text-purple-500 mt-1"></i>
                <div>
                  <p className="text-sm text-gray-400">Email</p>
                  <a href="mailto:info@escritoriobenderltda.com" className="text-sm text-gray-300 hover:text-purple-500 transition-colors">
                    info@escritoriobenderltda.com
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-phone-line text-lg text-purple-500 mt-1"></i>
                <div>
                  <p className="text-sm text-gray-400">Phone</p>
                  <a href="tel:+14435644613" className="text-sm text-gray-300 hover:text-purple-500 transition-colors">
                    +1 443 564 4613
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-line text-lg text-purple-500 mt-1"></i>
                <div>
                  <p className="text-sm text-gray-400">Address</p>
                  <p className="text-sm text-gray-300">
                    Av. CUJUBIM 2061<br />
                    CUJUBIM, Brazil<br />
                    76864-000
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-sm text-gray-400 hover:text-purple-500 transition-colors cursor-pointer"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-sm text-gray-400 hover:text-purple-500 transition-colors cursor-pointer"
                >
                  About
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('vpn-service')}
                  className="text-sm text-gray-400 hover:text-purple-500 transition-colors cursor-pointer"
                >
                  VPN Service
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('features')}
                  className="text-sm text-gray-400 hover:text-purple-500 transition-colors cursor-pointer"
                >
                  Features
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-sm text-gray-400 hover:text-purple-500 transition-colors cursor-pointer"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              © 2025 ESCRITORIO BENDER LTDA. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-purple-500 transition-colors cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
